import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './scss/aichat.module.scss';
import { assets } from '../../styles/assets/assets';
import { useDispatch, useSelector } from 'react-redux';
import { dashboardAction } from '../../store/slices/dashboard';
import socketService from '../../service/socket';
import { v4 as uuidv4 } from "uuid";
import { GetItemFromStorage } from '../../custom_hooks/useStorage';
import { LocalStorage } from '../../custom_hooks/localStorageKeys';
import { jwtDecode } from "jwt-decode";
import NlpWebSocketService from '../../constant/nlp_stt';
import { config } from '../../constant';
import ChatLikes from '../../components/Like/LikeDislike/chatLikes';

const AiChat = () => {
  const userDetails = GetItemFromStorage(LocalStorage?.ACCESS_TOKEN);
  const userData: any = jwtDecode(userDetails);
  const dispatch = useDispatch();

  const [expand, setExpand] = useState(false);
  const messages = useSelector((state: any) => state.dashboardReducer.aidashboard);
  const typing = useSelector((state: any) => state.dashboardReducer.isTyping);
  const loginDetails = useSelector((state: any) => state.dashboardReducer.loginDetails);
  console.log('loginDetails>>>>>>>>',messages)

  const [input, setInput] = useState("");
  console.log('input<>>>>>>>>>>>>>>>>',input)
  const [sessionId] = useState(uuidv4());
  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef<any>(null);

  const chatRef = useRef<HTMLTextAreaElement>(null);
  const msgEndRef = useRef<HTMLDivElement>(null);
  const transcriptRef = useRef('');
  const silenceCheckIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const lastSoundTimeRef = useRef<number>(Date.now());



  const [userdetails, setUserDetails] = useState<any>({});

  useEffect(() => {
    getUserDetails()
  }, [])
  const getUserDetails = () => {
    try {
      const token = GetItemFromStorage(LocalStorage.ACCESS_TOKEN)
      const data = jwtDecode(token)
      setUserDetails(data)
    } catch (error) {
      console.log(error)
    }
  }

  // Handle textarea input & auto-resize
  // const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
  //   const el = chatRef.current;
  //   if (el) {
  //     el.style.height = "auto";
  //     el.style.height = e.target.value.trim() === "" ? "34px" : `${el.scrollHeight}px`;
  //   }
  //   setInput(e.target.value);
  //   adjustHeight();
  // };

   const handleInput = (e: React.FormEvent<HTMLTextAreaElement>) => {
    const t = textareaRef.current;
    if (!t) return;

    const min = 34; // starting height
    const max = 200;

    // Reset height so shrinking works
    t.style.height = "0px";

    // Set new height based on scrollHeight
    const newHeight = t.scrollHeight;
    t.style.height = `${Math.max(min, Math.min(newHeight, max))}px`;
    setInput(e.target.value);
    adjustHeight();
  };


// const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
//   const el = chatRef.current;
//   if (!el) return;

//   el.style.height = "auto";
//   el.style.height = `${el.scrollHeight}px`;
//   setInput(e.target.value);
// };

useEffect(() => {
  const el = chatRef.current;
  if (el) {
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }
}, [expand]);
  // Send message
const handleSend = () => {
  if (!input.trim()) return;

  dispatch(dashboardAction.setAiChat({ id: Date.now(), text: input, isBot: 0 }));
  dispatch(dashboardAction.setTyping(true));

  const data = {
    domainId: userData?.domainId ?? 0,
    sessionId,
    message: input.trim(),
    ext: Number(userData?.ext) ?? 0,
    messageId: `${Date.now()}`
  };

  socketService.io.emit("aiChat", data);
  setInput("");

  // reset height smoothly once input cleared
 
};
  useEffect(()=>{
    console.log('userdetails>>>>>>>>',userdetails)
    if(messages.length<1){
    const data = {
      domainId: userData?.domainId ?? 0,
      sessionId,
      message:"hi",
      ext: Number(userData?.ext) ?? 0,
      messageId: `${Date.now()}`
    };
    dispatch(dashboardAction.setTyping(true));
    socketService.io.emit("aiChat", data);
   
  }
    // console.log("dttttt",data)
  },[])
  

  // Scroll to bottom on new messages or typing
  useEffect(() => {
    msgEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, typing]);

  useEffect(() => {
    if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      const SpeechRecognition =
        (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      recognition.continuous = true;
      recognition.interimResults = true;
      recognition.lang = 'en-US';

      recognition.onresult = (event: any) => {
        let transcript = '';
        for (let i = event.resultIndex; i < event.results.length; i++) {
          transcript += event.results[i][0].transcript;
        }
        // Update input as user speaks
        setInput(transcript);
      };

      recognition.onend = () => {
        setIsListening(false);
      };

      recognitionRef.current = recognition;
    } else {
      console.warn('Speech Recognition not supported in this browser.');
    }
  }, []);

  const nlpSocketUrl: any = config().STT_NLP;
  const [micOn, setMicOn] = useState(false);
  const audioContextRef = useRef<AudioContext | null>(null);
  const sourceRef = useRef<MediaStreamAudioSourceNode | null>(null);
  const processorRef = useRef<ScriptProcessorNode | null>(null);
  const streamRef = useRef<MediaStream | null>(null);
const adjustHeight = () => {
    const el = chatRef.current;
    if (!el) return;

    el.style.height = "auto";

    if (el.value.trim() === "") {
      el.style.height = "34px";
      return;
    }

    el.style.height = `${el.scrollHeight}px`;
  };

  const nlpService = NlpWebSocketService.getInstance();

 useEffect(() => {
  const service = NlpWebSocketService.getInstance();
  if (!service.isConnected()) {
    service.connect(nlpSocketUrl);
  }
}, []); // Only run once on mount


  function floatTo16BitPCM(float32Array: Float32Array) {
    const buffer = new ArrayBuffer(float32Array.length * 2);
    const view = new DataView(buffer);
    let offset = 0;
    for (let i = 0; i < float32Array.length; i++, offset += 2) {
      let s = Math.max(-1, Math.min(1, float32Array[i]));
      view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
    return new Int16Array(buffer);
  }

 const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  function downsampleBuffer(buffer: Float32Array, inputSampleRate: number, targetRate: number) {
    if (targetRate === inputSampleRate) return buffer;
    const sampleRateRatio = inputSampleRate / targetRate;
    const newLength = Math.round(buffer.length / sampleRateRatio);
    const result = new Float32Array(newLength);
    let offsetResult = 0, offsetBuffer = 0;
    while (offsetResult < result.length) {
      const nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
      let accum = 0, count = 0;
      for (let i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
        accum += buffer[i]; count++;
      }
      result[offsetResult] = accum / count;
      offsetResult++; offsetBuffer = nextOffsetBuffer;
    }
    return result;
  }
  const textareaIdRef = useRef(uuidv4());
  const subscriptionRef = useRef<(() => void) | null>(null);


const initializeNlpService = useCallback(() => {
  const nlpService = NlpWebSocketService.getInstance();
  const nlpSocketUrl: any = config().STT_NLP;

  if (!nlpService.isConnected()) {
    nlpService.connect(nlpSocketUrl, () => {
      console.log("✅ NLP WebSocket connected");
      nlpService.sendMessage(
        JSON.stringify({ session_id: textareaIdRef.current })
      );
    });
  } else {
    nlpService.sendMessage(
      JSON.stringify({ session_id: textareaIdRef.current })
    );
  }

  // ✅ Prevent duplicate subscriptions
  if (!subscriptionRef.current) {
const unsubscribe = nlpService.subscribe((msg) => {
  if (msg.text && msg.session_id === textareaIdRef.current) {
    const newText = msg.text.trim();

    // Always append new text to the existing input
    setInput((prev) => (prev + " " + newText).trim());

    // Update the transcript ref accordingly
    transcriptRef.current = transcriptRef.current + " " + newText;
  }
});

    subscriptionRef.current = unsubscribe;
  }
  return subscriptionRef.current;

}, []);



  const startRawRecording = async () => {
  try {
    const unsubscribe = initializeNlpService();

    nlpService.sendMessage(JSON.stringify({ session_id: textareaIdRef.current }));
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    streamRef.current = stream;
    const audioCtx = new AudioContext();
    audioContextRef.current = audioCtx;
    const source = audioCtx.createMediaStreamSource(stream);
    sourceRef.current = source;
    const processor = audioCtx.createScriptProcessor(4096, 1, 1);
    processorRef.current = processor;

    source.connect(processor);
    processor.connect(audioCtx.destination);

    let pcmBuffer: number[] = [];

    processor.onaudioprocess = (e) => {
      const input = e.inputBuffer.getChannelData(0);
      const downsampled = downsampleBuffer(input, audioCtx.sampleRate, 16000);

      // ✅ Detect if sound is present
      const rms = Math.sqrt(downsampled.reduce((sum, val) => sum + val * val, 0) / downsampled.length);
      if (rms > 0.01) {
        lastSoundTimeRef.current = Date.now(); // ✅ Update on sound
      }

      const pcm16: any = floatTo16BitPCM(downsampled);
      pcmBuffer.push(...pcm16);
      while (pcmBuffer.length >= 320) {
        const chunk = pcmBuffer.slice(0, 320);
        pcmBuffer = pcmBuffer.slice(320);
        nlpService.sendMessage(Int16Array.from(chunk).buffer);
      }
    };

    // ✅ Start silence check loop
    silenceCheckIntervalRef.current = setInterval(() => {
      const now = Date.now();
      const timeSinceLastSound = now - lastSoundTimeRef.current;

      if (timeSinceLastSound > 6000) { 
        stopRawRecording();
        setIsListening(false);
        clearInterval(silenceCheckIntervalRef.current!);
        silenceCheckIntervalRef.current = null;
      }
    }, 1000);

    setMicOn(true);
  } catch (err) {
    alert(err);
  }
};




 const stopRawRecording = async () => {
  try {
    processorRef.current?.disconnect();
    if (processorRef.current) processorRef.current.onaudioprocess = null;
    sourceRef.current?.disconnect();
    streamRef.current?.getTracks().forEach((t) => t.stop());
    await audioContextRef.current?.close();

    if (silenceCheckIntervalRef.current) {
      clearInterval(silenceCheckIntervalRef.current);
      silenceCheckIntervalRef.current = null;
    }

  } finally {
    processorRef.current = null;
    sourceRef.current = null;
    streamRef.current = null;
    audioContextRef.current = null;
  }
};


  const handleMicClick = () => {
    if (!recognitionRef.current) return;

    if (isListening) {
      stopRawRecording()
      setIsListening(false);
    } else {
      // setInput(''); 
      setIsListening(true);
      startRawRecording()
    }
    requestAnimationFrame(() => {
      const el = chatRef.current;
      if (el) {
        el.style.height = "34px";
      }
    });
    adjustHeight();
  };



  // ${styles.expandaichatsec}
  const handleExpandClick = () => setExpand(prev => !prev);
  const closeClick = () => dispatch(dashboardAction.setShowAiChat(false));

  useEffect(() => {
  return () => {
    if (subscriptionRef.current) {
      subscriptionRef.current(); // Unsubscribe on unmount
      subscriptionRef.current = null;
    }
  };
}, []);
requestAnimationFrame(() => {
  const el = chatRef.current;
  if (el) {
    el.style.height = "auto"; // reset back
  }
});


  return (
    <div className={`${styles.aichatsec} ${expand ? styles.expandaichatsec : ''}`}>
      {/* Header */}
      <div className={styles.sgnheader}>
        <span className={styles.expandwithheader} onClick={handleExpandClick}>
          <img
            src={expand ? assets.aiexpand_icon : assets.Worktualeg_logo}
            alt='expand'
            width={24}
            height={24}
          />
          Worktual AI Chat
        </span>
        <img src={assets.close_icon} alt="close_icon" onClick={closeClick} />
      </div>

      {/* Chat Body */}
      <div className={styles.sgnwrapper}>
        <div className={`${styles.sgnmain} ${expand ? styles.sgheight : ''}`}>
          <div className={styles.sgnchatsecwrapper}>
            <div className={styles.sgnchatssec}>
              {messages.map((msg: any,index:any) =>
                msg.isBot === 0 ? (
                <>
                <>
                { msg.text.length>0 &&
                  <div key={msg.id} className={styles.chatrights}>
                    <p className={styles.sendmsg}>{msg.text}</p>
          </div>
                }</>
                <div ref={msgEndRef} />

                {/* // history */}
                {/* <>
                 <div className={styles.historyinterface}>
          <div className={styles.title}>
              Today
          </div>
          {Array.from({ length: 40 }).map((_, index) => (
  <div className={styles.row} key={index}>
    new content 
    <span>del</span>
  </div>
))}
       </div>
                </> */}
                </>
                
                ) : (
                 <div key={msg.id} className={styles.chatlefts}>
                    <div className={styles.replymsg}>
                      {/* <img
                        src={assets.replay_logo}
                        alt="bot_logo"
                        className={styles.btlogo}
                        width={24}
                        height={24}
                        style={{ marginRight: 8 }}
                      /> */}
                      <div
                        className={`${styles.replymsgresponse} chatContent `}
                        dangerouslySetInnerHTML={{ __html: msg.message }}
                      />
          </div>
                  {/* <ChatLikes index={index} domainId={userData?.domainId} sessionId={sessionId} extension={ Number(userData?.ext)} messageId={msg?.messageId} feedbackDataProp={msg?.feedbackData} likeOrDislike={msg?.likeOrDislike} message={msg?.message}  /> */}
       </div>
                )
              )}

              {(typing || messages.length<1) && (
                 
                <div className={styles.chatlefts}>
                  <p className="generatings">
                    AI is Thinking
                    <div className='typingdot'>
                      <span></span><span></span><span></span>
                    </div>
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Footer / Input */}
          <div className={styles.sgnfooter}>
            <div className={styles.sgnfooterwrapper}>
              <div className={styles.adiconte}>
              <img src={assets.add_icon} alt='add_files' width={34} height={34} />
              <div className={styles.inputwrapper}>
                <textarea
                  ref={textareaRef}
                  value={input}
                  onFocus={adjustHeight}
                  onInput={handleInput}
                  onChange={handleInput}
                  placeholder="What can I do for you?"
                  onKeyDown={(e) => {
                    if(!typing && e.key ==="Enter"){
                      e.preventDefault();
                      handleSend();
                    }
                  }
                }
                />
                {!typing && input?.trim()?.length > 0 && <img onClick={handleSend} src={assets.Send_icon} alt="sendicon" width={24} height={24} className={styles.sendicon} />}
              </div>
              </div>
              <div className={styles.listeningtest}>
              {!isListening ?
              <img onClick={handleMicClick} src={assets.record_icon} alt='record' width={34} height={34} />
              :<svg onClick={handleMicClick} width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="38" height="38" rx="19" fill="#7423D7" />
                              <path d="M24.9911 20.2275C24.5907 20.1162 24.1776 20.3427 24.0634 20.7412C23.3202 23.3271 20.9189 25.1338 18.2236 25.1338C15.5507 25.1338 13.1543 23.3457 12.3965 20.7861C12.2803 20.3896 11.8662 20.1601 11.4649 20.2802C11.0674 20.3974 10.8409 20.8144 10.959 21.2118C11.832 24.1635 14.4568 26.268 17.4815 26.5722V28.3261C17.4815 28.7402 17.8174 29.0761 18.2315 29.0761C18.6456 29.0761 18.9815 28.7402 18.9815 28.3261V26.5707C22.0242 26.2595 24.649 24.1343 25.5049 21.1552C25.6192 20.7577 25.3896 20.3417 24.9911 20.2275Z" fill="#F0FAF7" />
                              <g filter="url(#filter0_i_3036_4344)">
                                <path d="M21.9571 17.1995L21.0801 15.1556C21.0332 15.0482 20.9463 14.9603 20.8399 14.9154L18.8399 14.058C18.3741 13.8266 18.1221 13.4291 18.1221 12.973C18.1221 12.5169 18.3741 12.1195 18.795 11.9085L20.8389 11.0315C20.9473 10.9846 21.0332 10.8987 21.0801 10.7893L21.3471 10.1665C20.5066 9.55758 19.4817 9.18848 18.3646 9.18848H18.0982C15.2792 9.18848 12.9941 11.4737 12.9941 14.2926V18.528C12.9941 21.347 15.2793 23.6321 18.0982 23.6321H18.3646C21.1834 23.6321 23.4686 21.3469 23.4686 18.528V17.7708C23.3282 17.8309 23.1805 17.8724 23.0216 17.8724C22.5655 17.8724 22.1681 17.6204 21.9571 17.1995Z" fill="#F0FAF7" />
                              </g>
                              <path d="M19.175 13.2766C19.0398 13.2095 18.9727 13.1081 18.9727 12.9729C18.9727 12.8384 19.0398 12.7372 19.175 12.6692L21.174 11.8126C21.4829 11.6802 21.7291 11.4341 21.8615 11.1251L22.7181 9.12613C22.7855 8.99163 22.8866 8.92383 23.0218 8.92383C23.1563 8.92383 23.2575 8.99163 23.3255 9.12613L24.1823 11.1252C24.3147 11.4341 24.5608 11.6802 24.8697 11.8126L26.8686 12.6692C27.0031 12.7373 27.0712 12.8384 27.0712 12.9729C27.0712 13.1081 27.0031 13.2095 26.8686 13.2766L24.8697 14.1332C24.5608 14.2656 24.3147 14.5117 24.1823 14.8206L23.3255 16.8197C23.2574 16.9549 23.1563 17.0223 23.0218 17.0223C22.8866 17.0223 22.7854 16.9549 22.7181 16.8197L21.8615 14.8207C21.7291 14.5118 21.483 14.2656 21.174 14.1332L19.175 13.2766Z" fill="#757676" />
                              <path d="M19.175 13.2766C19.0398 13.2095 18.9727 13.1081 18.9727 12.9729C18.9727 12.8384 19.0398 12.7372 19.175 12.6692L21.174 11.8126C21.4829 11.6802 21.7291 11.4341 21.8615 11.1251L22.7181 9.12613C22.7855 8.99163 22.8866 8.92383 23.0218 8.92383C23.1563 8.92383 23.2575 8.99163 23.3255 9.12613L24.1823 11.1252C24.3147 11.4341 24.5608 11.6802 24.8697 11.8126L26.8686 12.6692C27.0031 12.7373 27.0712 12.8384 27.0712 12.9729C27.0712 13.1081 27.0031 13.2095 26.8686 13.2766L24.8697 14.1332C24.5608 14.2656 24.3147 14.5117 24.1823 14.8206L23.3255 16.8197C23.2574 16.9549 23.1563 17.0223 23.0218 17.0223C22.8866 17.0223 22.7854 16.9549 22.7181 16.8197L21.8615 14.8207C21.7291 14.5118 21.483 14.2656 21.174 14.1332L19.175 13.2766Z" fill="url(#paint0_linear_3036_4344)" />
                              <defs>
                                <filter id="filter0_i_3036_4344" x="12.9941" y="9.18848" width="10.4746" height="16.4436" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="2" />
                                  <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                                  <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3036_4344" />
                                </filter>
                                <linearGradient id="paint0_linear_3036_4344" x1="18.3027" y1="12.9068" x2="27.2121" y2="9.92262" gradientUnits="userSpaceOnUse">
                                  <stop stop-color="#EA57FF" />
                                  <stop offset="0.945" stop-color="#FF5300" />
                                </linearGradient>
                              </defs>
              </svg>}
              <img src={assets.history_icon} alt='history_icon' width={34} height={34} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiChat;
